<div class="flex flex-col w-full justify-start items-stretch">
  @for (part of parts; track part.uuid; let index = $index) {
    <div class="flex flex-row justify-between items-center">
      <p class="flex flex-grow">
        {{ part.quantity }} x {{ part.name }} &commat;
        {{ part.price * part.quantity | hlCurrency | async }}
      </p>
      <div class="flex flex-row justify-start items-center w-auto flex-grow-0">
        <button mat-icon-button (click)="editPart(index)" type="button">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="removePart(index)" type="button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  }
  <app-parts-search (partAdded)="addPart($event)"></app-parts-search>
</div>
